import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { IconChart, IconLayers, IconSettings, IconSignOut } from "../ui/icons";

export default function Layout() {
  const navigate = useNavigate();

  const logout = async () => {
    await supabase.auth.signOut();
    navigate("/login");
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    [
      "inline-flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium",
      "transition-colors",
      isActive
        ? "text-brand-700 bg-brand-50"
        : "text-ink-600 hover:text-ink-900 hover:bg-silver-100",
    ].join(" ");

  return (
    <div className="min-h-full flex flex-col">
      <header className="sticky top-0 z-30 border-b border-silver-200 bg-white/90 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <NavLink to="/" className="flex items-center gap-3 group">
              <img
                src="/tfl-logo.png"
                alt="Tennis for Life"
                className="h-10 w-10 rounded-md object-contain"
              />
              <span className="hidden sm:inline text-sm font-semibold text-ink-800 tracking-tight">
                Tennis for Life
              </span>
              <span className="hidden sm:inline-block h-6 w-px bg-silver-300" />
              <span className="hidden sm:inline text-sm font-medium text-silver-500 tracking-wide">
                Content Engine
              </span>
            </NavLink>
            <nav className="flex gap-1">
              <NavLink to="/" end className={linkClass}>
                <IconLayers size={15} />
                <span className="hidden md:inline">Dashboard</span>
              </NavLink>
              <NavLink to="/analytics" className={linkClass}>
                <IconChart size={15} />
                <span className="hidden md:inline">Analytics</span>
              </NavLink>
              <NavLink to="/settings" className={linkClass}>
                <IconSettings size={15} />
                <span className="hidden md:inline">Settings</span>
              </NavLink>
            </nav>
          </div>
          <button
            onClick={logout}
            className="inline-flex items-center gap-1.5 text-sm text-ink-500 hover:text-ink-800 px-2 py-1.5 rounded-md hover:bg-ink-50 transition-colors"
          >
            <IconSignOut size={15} />
            <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </header>
      <main className="flex-1 max-w-7xl mx-auto w-full px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
}
